require.ensure(
    ["./vue", "./bootstrap"],
    function(require) {
        window.$ = window.jQuery = require("jquery");
        require("form-serializer")
        require("./vue");
        require("./bootstrap");
        const { jrNotifyError } = require("./bootstrap");
        const { $err } = require("./module/error-manager");

        jQuery.ready.then(function() {
            function handleBraintreeError(errorMsg, braintreeError) {
                // braintreeError = {code: '', details: '', message: '', type: ''}
                jrNotifyError("BraintreeError: " + errorMsg, braintreeError);
                $err.displayErrors(
                    [
                        {
                            title: errorMsg,
                            message: braintreeError.message,
                            details: braintreeError.details
                        }
                    ],
                    ".error-container"
                );
            }

            function immediatePayment() {
                return window.jrConfig.braintree && window.jrConfig.braintree.clientToken
                    ? true
                    : false;
            }

            function handleCardTypeSelection() {
                var current = $('input[name="sku"]:checked');
                if (current.length) {
                    if ($(current).data("email")) {
                        $("[data-email-label]").show();
                        $('input[name="giftcardsendemail_YN"]').val("Y");
                    } else {
                        $("[data-email-label]").hide();
                        $('input[name="giftcardsendemail_YN"]').val("N");
                    }
                    if ($(current).data("physical")) {
                        $("[data-physical-label]").show();
                    } else {
                        $("[data-physical-label]").hide();
                    }

                    // Immediate payment only if enabled!
                    if (immediatePayment()) {
                        if ($(current).val() == "GCE") {
                            $(".immediate-checkout").show();
                            $(".cart-checkout").hide();
                        } else {
                            $(".immediate-checkout").hide();
                            $(".cart-checkout").show();
                        }
                    }
                } else {
                    $("[data-physical-label]").hide();
                    $("[data-email-label]").hide();
                    $(".immediate-checkout").hide();
                    $(".cart-checkout").show();
                }
            }

            $('input[name="sku"]').change(handleCardTypeSelection);
            handleCardTypeSelection();

            if (immediatePayment()) {
                window.braintree.dropin.create(
                    {
                        authorization: window.jrConfig.braintree.clientToken,
                        container: "#dropin-container",
                        card: {
                            cardholderName: {
                                required: true
                            }
                        },
                        paypal: {
                            flow: "checkout",
                            amount: $('select[name="price"] option:selected').val(),
                            currency: "USD"
                        }
                    },
                    function(createErr, instance) {
                        if (createErr) {
                            handleBraintreeError("Payment initialization error", createErr);
                            return;
                        }

                        $('select[name="price"]').change(function() {
                            var amount = $('select[name="price"] option:selected').val();
                            instance.updateConfiguration("paypal", "amount", amount);
                        });

                        $("#submit-button").click(function(e) {
                            e.preventDefault();
                            if ($('form[name="giftcard"]').valid()) {
                                instance.requestPaymentMethod(function(
                                    requestPaymentMethodErr,
                                    payload
                                ) {
                                    if (requestPaymentMethodErr) {
                                        handleBraintreeError(
                                            "Payment request error",
                                            requestPaymentMethodErr
                                        );
                                        return;
                                    }

                                    // Submit payload.nonce to your server
                                    $(".error-container").empty();
                                    $(".immediate-checkout").hide();
                                    $(".giftcard-processing").show();
                                    $.ajax({
                                        dataType: "json",
                                        url: window.jrConfig.braintree.giftcardUrl,
                                        method: "POST",
                                        data: $.extend(
                                            true,
                                            {
                                                nonce: payload.nonce,
                                                cardtype: payload.type,
                                                details: $.extend(
                                                    true,
                                                    payload.details ? payload.details : {},
                                                    {
                                                        shippingAddress: payload.shippingAddress
                                                            ? payload.shippingAddress
                                                            : null
                                                    }
                                                ),
                                                'g-recaptcha-response': window.grecaptcha.getResponse()
                                            },
                                            $('form[name="giftcard"]').serializeObject()
                                        ),
                                        success: function(res) {
                                            // Navigate to receipt
                                            window.location.href = res.data.route;
                                        },
                                        error: function(err) {
                                            $(".giftcard-processing").hide();
                                            $(".immediate-checkout").show();
                                            jrNotifyError(
                                                "PurchaseError: Could not complete purchase",
                                                $.extend(true, {}, err ? err.responseJSON : null)
                                            );
                                            $err.ajaxError(err, ".error-container");
                                        }
                                    });
                                });
                            }
                        });
                    }
                );
            }

            $('form[name="giftcard"]').validate({
                rules: {
                    sku: {
                        required: true
                    },
                    nameoncard: {
                        required: true,
                        maxlength: 50
                    },
                    giftcardmessage: {
                        maxlength: 200
                    },
                    giftcardemail: {
                        email: true,
                        required: function() {
                            return $('input[name="sku"]:checked').data("email") ? true : false;
                        }
                    },
                    billphone: {
                        required: function() {
                            return $('input[name="sku"]:checked').val() == "GCE" ? true : false;
                        }
                    },
                    billemail: {
                        email: true,
                        required: function() {
                            return $('input[name="sku"]:checked').val() == "GCE" ? true : false;
                        }
                    }
                }
            });
        });
    },
    "standard_bootstrap"
);
